export default "__VITE_ASSET__7d5e24d4__"